import { createBrowserHistory } from "history";

// Exporta o histórico do browser com os tipos do TypeScript
const history = createBrowserHistory();

export default history;
